import { DefaultTheme } from 'styled-components'
import { Breakpoint } from '@mui/material/styles'

export interface ICentraThemeColors {
  dark: string
  black: string
  greyLight: string
  greySemiLight: string
  grey: string
  greySemiDark: string
  greyDark: string

  white: string
  red: string
  green: string
  yellow: string
  violet: string

  greyExtraDark: string
  greenLight: string
  greenSemiLight: string
  greenAcid: string
}

export interface ICentraTheme {
  fonts: Record<string, any>
  colors: ICentraThemeColors
  labels: {
    briefing: string
    needInformation: string
    inProgress: string
    done: string
    reject: string
    research: string
    other: string
    connection: string
    payment: string
    support: string
    openCabinet: string
    published: string
    unpublished: string
  }
  boxShadows: {
    blackLight: string
    greyLight: string
    yellow: string
  }
  breakpoints: {
    up: (key: number | Breakpoint) => string
    down: (key: number | Breakpoint) => string
  }
}

const fonts = {
  arial: 'Arial, sans-serif',
  inter: 'Inter',
}

const colors = {
  // basic colors
  dark: '#000',
  black: '#181A1A',
  greyLight: '#F5F5F5',
  greySemiLight: '#E8E8E8',
  grey: '#D0CFCF',
  greySemiDark: '#757575',
  greyDark: '#585858',
  greyExtraDark: '#2B2F2F',

  // secondary colors
  red: '#FF5C52',
  green: '#A8FF38',
  yellow: '#EFFD37',
  white: '#fff',
  violet: '#6862FF',

  greenLight: '#EDFF00',
  greenSemiLight: '#F5FF74',
  greenAcid: '#A8FF38',
}

const labels = {
  briefing: '#D5E1FF',
  needInformation: '#D0F9FF',
  inProgress: '#BEFFE8',
  done: '#E6FFB1',
  reject: '#FFD9D9',
  research: '#f6fe91',
  other: '#757575',
  connection: '#7A75FC',
  payment: '#F77AA9',
  support: '#2bbae8',
  openCabinet: '#0ABFA2',
  published: '#BEFFE8',
  unpublished: '#E8E8E8',
}

const boxShadows = {
  blackLight:
    '0px 15px 80px rgba(0, 0, 0, 0.28), 0px 4px 24.1177px rgba(0, 0, 0, 0.182445), 0px 3px 10.0172px rgba(0, 0, 0, 0.14), 0px 1px 3.62304px rgba(0, 0, 0, 0.0975551)',
  greyLight:
    '0px 100px 80px rgb(173 173 173 / 7%), 0px 41.7776px 33.4221px rgb(173 173 173 / 5%), 0px 22.3363px 17.869px rgb(173 173 173 / 4%), 0px 12.5216px 10.0172px rgb(173 173 173 / 4%), 0px 6.6501px 5.32008px rgb(173 173 173 / 3%), 0px 2.76726px 2.21381px rgb(173 173 173 / 2%)',
  yellow: '-10px 10px 20px rgba(206, 219, 36, 0.2)',
}

const breakpoints = {
  up: (width: number | Breakpoint) => `@media(min-width: ${width}px)`,
  down: (width: number | Breakpoint) => `@media(max-width: ${width}px)`,
}

const CentraTheme: DefaultTheme = {
  fonts,
  colors,
  labels,
  boxShadows,
  breakpoints,
}

const mq = (minWidth: number, type = 'min'): string => `@media (${type}-width: ${minWidth}px)`

export { colors, CentraTheme, mq }
